// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "./Base", "./Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("./Base"), require("./Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Base, global.Icon);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Base, _Icon) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    Button: true,
    PrimaryButton: true,
    SecondaryButton: true,
    TextButton: true
  };
  _exports.TextButton = _exports.SecondaryButton = _exports.PrimaryButton = _exports.Button = void 0;
  _react = _interopRequireDefault(_react);
  Object.keys(_Icon).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _Icon[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Icon[key];
      }
    });
  });
  var _excluded = ["className", "variant"];
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
  function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
  function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
  var COMMON_CLASS_NAMES = ['cop-shadow-none'];
  var VARIANT_CLASS_NAMES = {
    primary: ['cop-bg-[#212B36]', 'cop-text-white', 'cop-border-0'],
    secondary: ['cop-border', 'cop-border-solid', 'cop-border-slate-200', 'cop-bg-transparent', 'cop-text-black', 'enabled:hover:cop-bg-[#F8F9FB]'],
    text: ['cop-bg-transparent', 'cop-border-0', 'cop-text-black']
  };
  var DISABLED_CLASS_NAMES = {
    primary: ['cop-bg-[#212B36]', 'cop-text-white', 'cop-border-0'],
    secondary: ['cop-bg-white', 'cop-text-[#c9cbcd]', 'cop-border-black/10'],
    text: ['cop-text-disabled']
  };
  var P_CLASS_NAMES = {
    sm: ['cop-px-2', 'cop-py-[3px]'],
    base: ['cop-px-3', 'cop-py-1']
  };
  function getPaddingClassNames(variant, size) {
    if (variant === 'text') {
      return ['cop-py-0.5'];
    }
    return P_CLASS_NAMES[size];
  }
  var Button = _exports.Button = function Button(props) {
    var _props$size;
    var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'primary' : _props$variant,
      other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_Base.BaseButton, _extends({
      className: [].concat(COMMON_CLASS_NAMES, _toConsumableArray(VARIANT_CLASS_NAMES[variant]), _toConsumableArray(props.disabled ? DISABLED_CLASS_NAMES[variant] : []), _toConsumableArray(getPaddingClassNames(variant, (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 'base')), [className !== null && className !== void 0 ? className : '']).join(' ')
    }, other));
  };
  // For backward compatibility.
  var PrimaryButton = _exports.PrimaryButton = function PrimaryButton(props) {
    return /*#__PURE__*/_react["default"].createElement(Button, _extends({}, props, {
      variant: "primary"
    }));
  };
  var SecondaryButton = _exports.SecondaryButton = function SecondaryButton(props) {
    return /*#__PURE__*/_react["default"].createElement(Button, _extends({}, props, {
      variant: "secondary"
    }));
  };
  var TextButton = _exports.TextButton = function TextButton(props) {
    return /*#__PURE__*/_react["default"].createElement(Button, _extends({}, props, {
      variant: "text"
    }));
  };
});
